<template>
    <div id="info-container">
        <div class="vertical">
            <div class="info-field horizontal">
                <tr class="info-field-row">
                    <td style="width:200px;"><p class="info-field-title">{{ $t('CurrentPassword') }}</p></td>
                    <td style="width:200px;" class="info-field-value">
                        <input id="rpm-old" type="password" :placeholder="$t('CurrentPassword')">
                    </td>
                </tr>
            </div>
            <div class="info-field horizontal">
                <tr class="info-field-row">
                    <td style="width:200px;"><p class="info-field-title">{{ $t('NewPassword') }}</p></td>
                    <td style="width:200px;" class="info-field-value">
                        <input id="rpm-new" type="password" :placeholder="$t('NewPassword')">
                    </td>
                </tr>
            </div>
            <div class="info-field horizontal">
                <tr class="info-field-row">
                    <td style="width:200px;"><p class="info-field-title">{{ $t('RepeatNewPassword') }}</p></td>
                    <td style="width:200px;" class="info-field-value">
                        <input id="rpm-repeat" type="password" :placeholder="$t('RepeatNewPassword')">
                    </td>
                </tr>
            </div>
            <div>
                <div class="error" v-if="error != ''">{{ error }}</div>
            </div>
            <div style="align-self: center;">
                <Button :title="'Save'" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" @onClick="save"></Button>
            </div>
        </div>    
    </div>
</template>

<script>
import Button from '../Button.vue';
import Modal from '../Modal.vue';
import { changePassword } from '../../api/api';
export default {
    components: { Modal, Button },
    props: {
        email: {
            required: true,
            type: String
        }
    },  
    data() {
        return {
            error: ''
        }
    },
    methods: {
        save() {
            this.error = ''
            var pwd = document.getElementById('rpm-old').value
            var nw = document.getElementById('rpm-new').value
            var rep = document.getElementById('rpm-repeat').value
            changePassword({Email: this.email, OldPassword: pwd, NewPassword: nw, ConfirmNewPassword: rep})
                .then(() => {
                    // console.log('positive')
                    this.$emit('close')
                })
                .catch((error) => {
                    try {
                        this.error = error.response.data.map(m => m.description).join('\n');
                    } catch (e) {
                        if(this.error == ''){
                            this.error = error.response.data
                        }
                    }
                })
        }
    },
    mounted() {
    }
}
</script>

<style scoped>
.error {
    text-align: left !important;
    color: #FD8282;
    font-size: 11px;
    font-weight: bold;
    font-family: 'Open Sans', sans-serif !important;
    font-style: normal !important;
    font-weight: 400 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/ResetPasswordModal.vue